<template>
  <div>
    <!-- 已上传图片 -->
    <div class="has-upload" v-show="imgUrl" @mouseenter="isHover = true" @mouseleave="isHover = false">
      <img :src="imgUrl" alt="" />
      <div class="mask" v-show="isHover">
        <a-button class="btn" @click="showPreview = true">查看大图</a-button>
        <a-button class="btn" @click="onReset">重新上传</a-button>
        <a-button class="btn" @click="onDelete">删除</a-button>
      </div>
    </div>

    <!-- 未上传图片 -->
    <a-upload ref="upload" v-show="!imgUrl" class="avatar-uploader" :customRequest="uploadFun" :show-upload-list="false" :before-upload="beforeUpload" @change="handleChange">
      <div class="no-upload">
        <svg-icon v-if="!loading" icon-class="add" class="svg-icon cr-mb-1"></svg-icon>
        <a-icon v-else class="cr-mb-1 cr-icon cr-text-primary" type="loading" />
        <div class="cr-text-black-1 ct-mt-1" v-html="upText"></div>
      </div>
    </a-upload>

    <preview-img :url="imgUrl" :show.sync="showPreview"></preview-img>
  </div>
</template>

<script>
import { uploadImg } from '@/api/caseDetail'
import PreviewImg from './PreviewImg.vue'
export default {
  components: { PreviewImg },
  model: {
    prop: 'imgUrl',
    event: 'change'
  },
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    upText: {
      type: String,
      default: '营业执照副本扫描件'
    }
  },
  data() {
    return {
      loading: false,
      isHover: false,
      showPreview: false
    }
  },
  methods: {
    onReset() {
      this.$nextTick(() => {
        this.$refs.upload.$el.querySelector('.no-upload').click()
      })
    },
    onDelete() {
      this.$emit('change', '')
    },
    // 自定义上传方法
    async uploadFun(val) {
      let file = val.file
      const formData = new FormData()
      formData.append('file', file)
      try {
        const res = await uploadImg(formData)
        this.$emit('change', res.data)
        this.loading = false
      } catch (error) {
        console.log('上传失败')
        this.loading = false
      }
    },
    handleChange(info) {
      if (info.file.status === 'uploading') {
        this.loading = true
      }
      if (info.file.status === 'done') {
        this.loading = false
      }
    },
    beforeUpload(file) {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('只能上传jpg和png格式的图片哦!')
      }
      return isJpgOrPng
    }
  }
}
</script>

<style lang="less" scoped>
.has-upload {
  width: 160px;
  height: 120px;
  border-radius: 2px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    .btn {
      width: 80px;
      background: #2c69f6;
      color: #fff;
      border: none;
    }
  }
}
.avatar-uploader {
  width: 160px;
  height: 120px;
  font-size: 14px;
  overflow: hidden;
  .no-upload {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px dashed @theme-color;
    cursor: pointer;
    border-radius: 2px;
    text-align: center;
    .svg-icon {
      height: 36px;
      width: 36px;
    }
    .cr-icon {
      font-size: 32px;
    }
  }

  ::v-deep .ant-upload {
    width: 160px;
    height: 120px;
    background: rgba(71, 125, 186, 0.07);
  }
}
</style>
